import { __awaiter } from "tslib";
import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from '../types';
import { MISSING_CUSTOMER } from '@open-tender/types';
import { checkAuth, selectToken } from './account';
const initialState = {
    entities: [],
    error: null,
    loading: 'idle',
    lookup: {}
};
export var CustomerLoyaltyActionType;
(function (CustomerLoyaltyActionType) {
    CustomerLoyaltyActionType["FetchCustomerLoyalty"] = "customer/fetchCustomerLoyalty";
})(CustomerLoyaltyActionType || (CustomerLoyaltyActionType = {}));
export const fetchCustomerLoyalty = createAsyncThunk(CustomerLoyaltyActionType.FetchCustomerLoyalty, (_, { dispatch, getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const token = selectToken(getState());
        if (!token)
            throw new Error(MISSING_CUSTOMER);
        return yield api.getCustomerLoyaltyV2(token);
    }
    catch (err) {
        const error = err;
        return checkAuth(error, dispatch, () => rejectWithValue(error));
    }
}));
const customerLoyaltySlice = createSlice({
    name: ReducerType.Loyalty,
    initialState,
    reducers: {
        resetCustomerLoyalty: () => initialState,
        resetCustomerLoyaltyError: state => {
            state.error = null;
            state.loading = 'idle';
        },
        setCustomerLoyalty: (state, action) => {
            var _a;
            state.entities = (_a = action.payload) !== null && _a !== void 0 ? _a : [];
            state.error = null;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchCustomerLoyalty.fulfilled, (state, action) => {
            var _a;
            state.entities = (_a = action.payload) !== null && _a !== void 0 ? _a : [];
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchCustomerLoyalty.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchCustomerLoyalty.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        });
    }
});
export const { resetCustomerLoyalty, resetCustomerLoyaltyError, setCustomerLoyalty } = customerLoyaltySlice.actions;
export const selectCustomerLoyalty = (state) => state.customer.loyalty;
export const selectCustomerLoyaltyProgram = createSelector((state) => {
    const { entities, loading, error } = state.customer.loyalty;
    return { entities, loading, error };
}, ({ entities, loading, error }) => {
    const programs = entities.filter(i => i.earn_order_type === null || i.earn_order_type === 'OLO');
    const program = programs.length ? programs[0] : null;
    return { program, loading, error };
});
export const selectHasPointsShop = createSelector((state) => {
    const { entities } = state.customer.loyalty;
    return { entities };
}, ({ entities }) => {
    return !!entities.find(i => i.is_points_shop_enabled);
});
export const selectCustomerPointsProgram = (orderType) => createSelector((state) => {
    const { loyalty } = state.customer;
    const { entities: loyaltyPrograms } = loyalty;
    return { loyaltyPrograms };
}, ({ loyaltyPrograms }) => {
    if (!loyaltyPrograms)
        return null;
    const programs = loyaltyPrograms.filter(i => {
        var _a;
        return ((_a = i.perk) === null || _a === void 0 ? void 0 : _a.loyalty_perk) === 'BANKABLE_POINTS' &&
            (i.earn_order_type === null || i.earn_order_type === orderType);
    });
    return programs.length ? programs[0] : null;
});
export const selectCustomerPoints = (orderType) => (state) => {
    const program = selectCustomerPointsProgram(orderType)(state);
    if (!program || !program.perk)
        return null;
    const { spend_name, perk } = program;
    return { name: spend_name, points: perk.credit };
};
export const selectPointsProgram = (state) => {
    const { orderType } = state.order;
    return orderType ? selectCustomerPointsProgram(orderType)(state) : null;
};
export const customerLoyaltyReducer = customerLoyaltySlice.reducer;
